// src\store\pinia.ts
import { defineStore } from "pinia";
import * as Helper from "@/helper";

const KEY_LOGIN_KEY = "KEY_LOGIN_KEY";

export const useStore = defineStore("apps", {
  state: () => ({
    count: 0,
    text: "Eduardo",
    interval_id: 0,
    interval_func: () => {},
    //
    login_key: "",
  }),
  getters: {
    doubleCount: (state) => state.count * 2,
  },
  actions: {
    increment() {
      this.count++;
    },
    async wait_inc() {
      var p = new Promise((resolve) => {
        setTimeout(() => {
          this.count++;
          resolve(undefined);
        }, 3000);
      });
      await p;
    },
    app_init() {
      console.log("pinia app_init start");
      const login_key = localStorage.getItem(KEY_LOGIN_KEY);
      // console.log("vuex app_init login_key", login_key);
      if (login_key) {
        this.login_key = login_key;
        Helper.set_login_key(login_key);
      }

      // if (this.interval_id == 0) {
      //   this.interval_id = setInterval(() => {
      //     this.interval_func();
      //   }, 1000);
      // }
    },
    set_login_key(login_key: string) {
      if (this.login_key == login_key) return;
      console.log("vuex set_login_key start");

      this.login_key = login_key;
      Helper.set_login_key(login_key);
      localStorage.setItem(KEY_LOGIN_KEY, login_key);
    },
    set_interval(func: () => void) {
      this.interval_func = func;
    },
  },
});
